import "./ProjectorRoom.css";
import { useRef, useState } from "react";

// DEFAULT / FALLBACK VIDEOS
import introVideo from "./assets/bci.mp4";
import typesVideo from "./assets/python.mp4";
import supervisedVideo from "./assets/ai.mp4";

export default function ProjectorRoom() {
  const videoRef = useRef(null);
  const fileInputRef = useRef(null);

  const [lessons, setLessons] = useState([
    { title: "Discover who we are and how we transform careers", time: "12:09", video: introVideo },
    { title: "Start coding with the world’s most in-demand language", time: "10:00", video: typesVideo },
    { title: "Learn how AI is transforming every industry", time: "11:30", video: supervisedVideo },
  ]);

  const [current, setCurrent] = useState(0);
  const [playing, setPlaying] = useState(false);

  /* ▶ PLAY / PAUSE */
  const playPause = () => {
    if (!videoRef.current) return;

    if (playing) {
      videoRef.current.pause();
    } else {
      videoRef.current.play();
    }
    setPlaying(!playing);
  };

  /* ⏭ NEXT LESSON */
  const nextLesson = () => {
    if (current < lessons.length - 1) {
      setCurrent(current + 1);
      setPlaying(false);
    }
  };

  /* ⛶ FULLSCREEN */
  const fullscreen = () => {
    if (videoRef.current?.requestFullscreen) {
      videoRef.current.requestFullscreen();
    }
  };

  /* 📂 UPLOAD LOCAL VIDEO */
  const uploadVideo = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const videoURL = URL.createObjectURL(file);

    const updatedLessons = [...lessons];
    updatedLessons[current] = {
      ...updatedLessons[current],
      video: videoURL,
    };

    setLessons(updatedLessons);
    setPlaying(false);
  };

  return (
    <div className="projector-room">

      {/* ===== MAIN PROJECTOR SCREEN ===== */}
      <div className="projector-screen">

        <div className="video-container">
          <video
            ref={videoRef}
            src={lessons[current].video}
            className="projector-video"
            onEnded={() => setPlaying(false)}
            controls={false}
          />
          <div className="views-badge">5 Million+ Views</div>
        </div>

        <div className="lesson-info">
          <h3>
            Lesson {current + 1}: {lessons[current].title}
          </h3>
          <p>Tutor: shifa khousain· {lessons[current].time}</p>
        </div>

        <div className="projector-controls">
          <button onClick={playPause}>
            {playing ? "⏸ Pause" : "▶ Start Lesson"}
          </button>

          <button onClick={nextLesson}>⏭ Next Lesson</button>

          <button onClick={fullscreen}>⛶ Fullscreen</button>

          {/* Upload Button */}
          {/* <button onClick={() => fileInputRef.current.click()}>
            📂 Upload Video
          </button> */}

          <input
            type="file"
            accept="video/*"
            ref={fileInputRef}
            onChange={uploadVideo}
            style={{ display: "none" }}
          />
        </div>

      </div>

      {/* ===== SIDE PANEL ===== */}
      <div className="projector-panel">

        <h3>Welcome to BCI — Your Career Starts Here</h3>

        {lessons.map((l, i) => (
          <div
            key={i}
            className={`lesson-item ${i === current ? "active" : ""}`}
            onClick={() => {
              setCurrent(i);
              setPlaying(false);
            }}
          >
            ⭐ {l.title}
            <span>{l.time}</span>
          </div>
        ))}

        <div className="stars-box">✨ +10 Stars Earned!</div>

        <button className="chat-btn">💬 Chat Rhea</button>

      </div>

    </div>
  );
}
